import React, { useState, useEffect, createRef, useRef } from 'react';
import { Col, Row, Button, Badge } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as commonActions from '@common/common.action';
import * as certificacaoActions from '@common/certificacao/certificacao.action';
import WebapiCommon from '@common/util/webapi.common';
import { statusEtapasEnum, etapasEnum } from '@common/util/defaultValues';
import ModalConfirmar from '@common/modalConfirmar/modalConfirmar';
import MorfologiaContainer from '@common/morfologia/morfologia.container';
import ListaLaminasContainer from '@common/tabs/listaLaminas/lista-laminas.container';
import AnexoContainer from '@common/tabs/anexo/anexo.container';
import AutoTextoContainer from '@common/tabs/autotexto/autotexto.container';
import LaudosAnterioresContainer from '@common/tabs/anteriores/laudos-anteriores.container';
import ModalComponentAsync from '@componentes/modal/modal.async';
import ModalComponent from '@componentes/modal/modal.component';
import * as actions from './conclusao.action';
import * as editorActions from '../../editor/editor.action';
import * as modalLiberarParcialmenteAction from '../../modais/liberacao_parcial/store/liberacao.action';
import * as modalLiberarLaudoAction from '../../modais/liberacao_total/store/liberacaoTotal.action';
import * as acessos from '../../../../acessos.const.util';
import * as editor from '../../editor/editor.util';
import { verificarPlainTextMudou } from '../../editor/editor.util';
import { acessoPermitido } from '../../../../acessos.seguranca';
import { LOCAL_STORAGE_USUARIO } from '../../../../localStorage.util';
import { errors } from '../../../error/erros';
import ButtonFloating from '../../../../componentes/button/button-floating.component';
import AutorizacaoLaudarContainer from '../../../../app/common/autorizacaoLaudar/autorizacao-laudar.container';
import CancelamentoComponent from '@componentes/cancelamento/cancelamento.component';
import ModalLiberacaoParcial from '../../modais/liberacao_parcial';
import ModalLiberacaoTotal from '../../modais/liberacao_total';
import ConfirmarCancelamento from '../../../../componentes/cancelamento/confirmacao.component';
import HistoricoLaudoContainer from '../macroscopia/tabs/historicolaudo/historico-laudo.container';
import ConfiguracaoApi from '../../../configuracao/configuracao.api';
import { editorUrl } from '@constants/defaultValues';
import IntlMessage from '../../../../helpers/intlMessage';
import { useIntl } from 'react-intl';
import ModalEncaminhar from '@common/modalEncaminhar/modalEncaminhar';
import ModalFaturamentoContainer from '../../../main/listagem/modais/faturamento/modal.faturamento.container';
import { useHistory } from 'react-router-dom';
import ExamesEmAbertoContainer from '../../etapas/macroscopia/operacoes/exames/exames.container';
import { urlImagemRadiologia } from '../etapas.common.util';
const refModalCid = createRef();
const MODAL_FECHADO = true;

function ConclusaoContainer(props) {
	const intl = useIntl();
	const history = useHistory();

	const [avisoCertificacao, setAvisoCertificacao] = useState(false);
	const [avisoCertificacaoLiberacao, setAvisoCertificacaoLiberacao] = useState(false);
	const [verificarTexto, setVerificarTexto] = useState(false);
	const [tipoVerificacao, setTipoVerificacao] = useState('');
	const [textoEditor, setTextoEditor] = useState('');
	const [callbackAutorizar, setCallbackAutorizar] = useState(undefined);
	const [modalAutorizacaoLaudar, setModalAutorizacaoLaudar] = useState(false);
	const [showModalCancelamento, setShowModalCancelamento] = useState(false);
	const [justificativaCancelar, setJustificativaCancelar] = useState('');
	const [modalConfirmar, setModalConfirmar] = useState(false);
    const [modalEncaminhar, setModalEncaminhar] = useState(false)
	const [modalConfirmarTitulo] = useState('Atenção!');
	const [modalConfirmarMensagem, setModalConfirmarMensagem] = useState('');
	const [modalConfirmarType, setModalConfirmarType] = useState('ok');
	const [modalEncaminharType, setModalEncaminharType] = useState('ok');
	const [modalVisivel, setModalVisivel] = useState(false);
	const [modalTitulo, setModalTitulo] = useState('');
	const [modalConteudo, setModalConteudo] = useState(undefined);
	const [modalSize, setModalSize] = useState('lg');
	const [updateCertificado, setUpdateCertificado] = useState(false);
	const usuarioLocal = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USUARIO));
	const [habilitadoCertificacao, setHabilitadoCertificacao] = useState();
	const [existemImagemsRadiologia, setExistemImagensRadiologia] = useState(false);
	const [
		showModalConfirmarCancelamentoState,
		setShowModalConfirmarCancelamentoState,
	] = useState(false);

	const hasHabilitado = () => {
		ConfiguracaoApi.getConfigCertificacaoDigital()
			.then((res) => {
				setHabilitadoCertificacao(res.certificacao_Habilitar)
			})
	}

	const firstLoad = useRef();

	useEffect(() => {
		if (firstLoad.current) {
			!props.modalFaturamento && props.laudoFaturado && handleLiberarLaudo();
		}
		firstLoad.current = true;

	}, [props.modalFaturamento]);

	useEffect(() => {
		WebapiCommon.verificarSeExistemImagensRadiologica(props.detalhes.acNumber, props.detalhes.prontuario).then((resultado) =>{
		  setExistemImagensRadiologia(resultado);
		  if (props.editorInicializado && resultado){
			props.commonActions.showAlerta('alerta', <IntlMessage id="dashboards.examDetails.imagesVivaceConnect" />, 7000, '650px');
		  }
		});
	  }
	  , [props.editorInicializado]);

	useEffect(() => {
		hasHabilitado();
		props.commonActions.mudarStatusLaudoFaturado(props.detalhes.laudoFaturado); //Ver nome do detalhes
		props.commonActions.alterarVisibilidadeAbas({});
		try {
			editor.Inicializar(props, etapasEnum.CONCLUSAO.toLowerCase());
		} catch (error) {
			const { message } = error;
			let title = '';
			const origin = `Etapa: ${etapasEnum.CONCLUSAO}`;
			const code = 101;

			errors.map((err) => {
				if (err.code === code) {
					title = err.title;
				}
				return err;
			});
			window.location.replace(
				`/error/${btoa(title)}/${btoa(message)}/${btoa(code)}/${btoa(origin)}/`
			);
		}

		const laudarEtapaRequest = {
			pendente: true,
			notificacaoCancer: false,
			exameId: props.detalhes.exameId,
			medicoSolicitante: props.detalhes.solicitante,
			medicoEtapa: props.editor.medExecutante,
			medicoRevisor: props.editor.medRevisor,
		};

		const etapa = props.detalhes.etapas.find(
			(el) => el.etapa === etapasEnum.CONCLUSAO
		);
		props.actions.conclusaoFinalizada(
			etapa.status === statusEtapasEnum.REALIZADO
		);
		props.commonActions.argumentosSalvarEtapaLaudo(laudarEtapaRequest);

		return () => {
			editor.finalizar(props.commonActions);
		};
	}, []);

	useEffect(() => {
		if (firstLoad.current) {
		if (!props.modalCertificacao && avisoCertificacao && !updateCertificado) {
			setAvisoCertificacao(false);
			setUpdateCertificado(true);
			return laudar(false, true);
		}
		if (
			!props.modalCertificacao &&
			avisoCertificacaoLiberacao &&
			!updateCertificado
		) {
			setAvisoCertificacaoLiberacao(false);
			setUpdateCertificado(true);
			return handleLiberarLaudo();
		}
	}
	}, [avisoCertificacaoLiberacao, props.modalCertificacao]);

	useEffect(() => {
		window.addEventListener('message', ({ data }) => {
			if (data.value) {
				if (data.value.plain) {
					setTextoEditor(data.value.plain);
				}
			}
		});

		return () => {
			window.removeEventListener('message', null, true);
			props.commonActions.mudarStatusLaudoFaturado(false);
		}

	}, []);

	useEffect(() => {
		if (textoEditor !== undefined && verificarTexto) {
			setVerificarTexto(false);
			props.commonActions.showFadeCarregando(true);
			if (!textoEditor || textoEditor.trim() === '') {
				props.commonActions.showFadeCarregando(false);
				return tipoVerificacao === 'cid' ? showModal('2') : showModal('3');
			}
			props.commonActions.showFadeCarregando(false);
			if (tipoVerificacao === 'cid') {
				return showModal('1');
			}
			if (tipoVerificacao === 'concluir') {
				const isValid = validarLaudar(false, false);
				if (!isValid) {
					return;
				}
				return laudar(false, true);
			}
			const isValid = validarLaudar(false, false);
			if (!isValid) {
				return;
			}
			return laudar(false, false);
		}
	}, [textoEditor, verificarTexto, tipoVerificacao]);

	const closeModal = () => {
		setModalVisivel(false);
	};

	const fecharModalConfirmar = () => {
		setModalConfirmar(!modalConfirmar);
	};

	const fecharModalEncaminhar = () => {
		setModalEncaminhar(!modalEncaminhar);
	};

	const showModal = (index) => {
		let componente;
		let titulo = '';
		const { laudo } = props.detalhes;
		let size = 'lg';

		switch (index) {
			case '1':
				componente = <MorfologiaContainer altura={window.innerHeight - 215} />;
				titulo = intl.formatMessage({id:"dashboards.examDetail.CIDReport"})
				break;
			case '2':
				setModalConfirmarMensagem(intl.formatMessage({id:"dashboards.examDetail.wasNotTyped"}));
				setModalConfirmarType('ok');
				setModalConfirmar(true);
				return;
			case '3':
				setModalConfirmarMensagem(
					intl.formatMessage({id:"dashboards.examDetail.notTyped"}),
				);
				setModalConfirmarType('ok');
				setModalConfirmar(true);
				return;
			case '4':
				componente = <ExamesEmAbertoContainer />;
				titulo = intl.formatMessage({ id: "dashboards.examDetails.openExamReport" });
				break;
			default:
				componente = undefined;
				break;
		}
		setModalConteudo(componente);
		setModalTitulo(titulo);
		setModalVisivel(true);
		setModalSize(size);
	};

	const showModalConfirmarCancelamento = () => {
		setShowModalConfirmarCancelamentoState(true);
	};

	const toggleModalConfirmarCancelamento = () => {
		setShowModalConfirmarCancelamentoState(false);
	};

	const cancelarEtapasPosteriores = () => {
		props.commonActions.showFadeCarregando(true);
		const listagem = [...props.listagem];
		const listagemIndex = listagem.findIndex(
			(item) => item.laudo === props.detalhes.laudo
		);
		if (listagemIndex >= 0) {
			if (listagem[listagemIndex].dataLiberacao) {
				listagem[listagemIndex].dataLiberacao = '';
			}
			listagem[listagemIndex].isLaudoLiberado = false;
			listagem[listagemIndex].isLiberadoParcial = false;
			listagem[listagemIndex].isLiberadoTotal = false;
			props.commonActions.preencherListagem(listagem);
		}
		WebapiCommon.cancelarEtapasPosteriores(
			props.detalhes.laudo,
			props.etapaAtual,
			0,
			justificativaCancelar
		)
			.then((resp) => {
				if (resp.success) {
					props.commonActions.showAlerta('sucesso', resp.data.mensagem, 2000);
					WebapiCommon.obterStatusEtapasLaudo(props.detalhes.laudo).then(
						(etapas) => {
							props.commonActions.atualizarStatusDasEtapasDoLaudo(
								etapas,
								props.detalhes.laudo
							);
							props.commonActions.showEditor(false);
							props.commonActions.showFadeCarregando(false);
							toggleModalCancelamento();
							toggleModalConfirmarCancelamento();
							_fechar();
						}
					);
				} else {
					props.commonActions.showFadeCarregando(false);
					props.commonActions.showAlerta(
						'erro',
						intl.formatMessage({id:"dashboards.examDetail.unableCancelSteps"}),
						2000
					);
					toggleModalCancelamento();
					toggleModalConfirmarCancelamento();
				}
			})
			.catch(() => {
				props.commonActions.showFadeCarregando(false);
				props.commonActions.showAlerta(
					'erro',
					intl.formatMessage({id:"dashboards.examDetail.unableCancelSteps"}),
					2000
				);
				toggleModalCancelamento();
				toggleModalConfirmarCancelamento();
			});
	};

	const _fechar = () => {
		history.goBack();
		//props.commonActions.atualizarDetalhes(undefined);
		props.commonActions.preenhcerHistoricoInconformidades(undefined);
		props.commonActions.atualizarLarguraEditor('100%');
		props.commonActions.showEditor(false);
	};

	const cancelamentoConclusao = () => {
		setShowModalCancelamento(true);
	};

	const toggleModalCancelamento = () => {
		setJustificativaCancelar('')
		setShowModalCancelamento(false);
	};

	const setJustificativa = (texto) => {
		setJustificativaCancelar(texto);
	};

	const alterarFullscreen = () => {
		props.commonActions.preencherAtalho('ctrl+alt+f10');
	};



	const verificaEditor = (tipo) => {
		const frame = document.getElementById('iframe-editor');
		if (frame !== null) {
			frame.contentWindow.postMessage(
				{
					method: 'recuperarTextoRtfAndPlainText',
					urlHost: editorUrl,
					args: {
						action: 'getPlainText',
					},
				},
				editorUrl
			);
		}
		setTimeout(() => {

			setTipoVerificacao(tipo);
			return setVerificarTexto(true);
		}, 200);
	};

	const editarMedico = (medico) => {
		const etapa = props.detalhes.etapas.find(
			(et) => et.etapa === etapasEnum.CONCLUSAO
		);
		let atb = {
			item: 'medico',
			detalhes: 'medConclusao',
		};

		if (etapa.status === statusEtapasEnum.REVISAO) {
			atb = {
				item: 'revisor',
				detalhes: 'revisorConclusao',
			};
		}
		WebapiCommon.editarMedicoResponsavelLaudo(
			props.detalhes.laudo,
			medico,
			etapasEnum.CONCLUSAO,
			atb.item
		).then(() => {
			const detalhes = {
				...props.detalhes,
			};
			detalhes[atb.detalhes] = medico;
			props.commonActions.atualizarDetalhes(detalhes);
		});
	};

	const validarLaudar = (pendente, conferencia) => {
		if (!usuarioLocal.medicoId && !pendente && !conferencia) {
			props.commonActions.showAlerta(
				'erro',
				intl.formatMessage({id:"dashboards.examDetail.onlyDoctors"}),
				2000
			);
			return false;
		}
		const etapaMacro = props.detalhes.etapas.find(
			(el) => el.etapa.toLowerCase() === etapasEnum.MACRO.toLowerCase()
		);

		if (
			etapaMacro.status !== statusEtapasEnum.REALIZADO &&
			!pendente &&
			etapaMacro.status !== statusEtapasEnum.CONFERENCIA
			&& etapaMacro.status !== statusEtapasEnum.NAO_APLICAVEL
		) {
			const mensagem =
				'É necessário finalizar a MACRO antes de realizar esta ação!';
			props.commonActions.showAlerta('erro', mensagem, 5000, '500px');
			return false;
		}
		return true;
	};

	const laudar = (pendente, concluir, conferencia = false) => {
		if (
			habilitadoCertificacao &&
			!pendente &&
			concluir &&
			!avisoCertificacao &&
			!props.detalhes.certificado &&
			acessoPermitido(props.usuario, acessos.CertificacaoDigital)
		) {
			props.certificacaoActions.certificadosSelecionados([
				props.detalhes.laudo,
			]);
			props.certificacaoActions.showModal(true);
			setAvisoCertificacao(true);
		} else if (!pendente && !conferencia) {
			WebapiCommon.getCIDPorLaudo(props.detalhes.laudo).then((result) => {
				const existe = result.length > 0;
				const existePrincipal = result.find(
					(morfologia) => morfologia.cidPrincipal
				);

				if (existePrincipal || !props.detalhes.obrigatorioMorfo) {
					laudarEtapa(pendente, concluir);
				} else if (existe && !existePrincipal) {
					props.commonActions.showAlerta(
						'alerta',
						intl.formatMessage({id:"dashboards.examDetail.setCID"}),
						2500
					);
				} else {
					props.commonActions.showAlerta(
						'alerta',
						intl.formatMessage({id:"dashboards.examDetail.informCID"}),
						2500
					);
				}
			});
		} else {
			laudarEtapa(pendente, concluir, conferencia);
		}
	};

	const encaminharSegundaOpiniao = () => {
		setModalEncaminhar(!modalEncaminhar)
	}

	const laudarEtapa = (pendente, concluir, conferencia = false) => {
		const laudarEtapaRequest = {
			...props.laudarEtapaRequest,
			pendente,
			concluirLaudo: concluir,
			medicoSolicitante: props.detalhes.solicitante,
			medicoEtapa: props.editor.medExecutante,
			medicoRevisor: props.editor.medRevisor,
			medicoLogadoId: usuarioLocal.medicoId,
			laudarParaConferencia: conferencia,
		};

		if (usuarioLocal.isResidente && !pendente && !conferencia) {
			setModalAutorizacaoLaudar(true);
			setCallbackAutorizar({
				sucesso: (medico_autorizou) => {
					setModalAutorizacaoLaudar(false);
					editarMedico(medico_autorizou);
					props.commonActions.argumentosSalvarEtapaLaudo(laudarEtapaRequest);
					editor.laudar(props.commonActions, concluir);

					props.commonActions.showAlerta(
						'sucesso',
						intl.formatMessage({id:"dashboards.examDetail.reportSave"}),
						2000
					);
					 history.goBack();
				},
				error: () => {
					props.commonActions.showAlerta(
						'erro',
						intl.formatMessage({id:"dashboards.examDetail.notAllowed"}),
						2000
					);
				},
			});
		} else {
			props.commonActions.argumentosSalvarEtapaLaudo(laudarEtapaRequest);
			editor.laudar(props.commonActions, concluir);
			props.commonActions.showAlerta(
				'sucesso',
				intl.formatMessage({id:"dashboards.examDetail.reportSave"}),
				2000
			);
		}
	};

	const showModalCID = () => {
		if (props.detalhes.critico)
			setModalTitulo(
				intl.formatMessage({id:"dashboards.examDetail.mandatoryCID"}), `${props.detalhes.laudo}`
			);
		else setModalTitulo(`CID do laudo ${props.detalhes.laudo}`);

		const modal = refModalCid.current;

		return new Promise((resolve, reject) => {
			setTimeout(async () => {
				try {
					await modal.show();
				} catch (err) {
					reject(err);
				}
				resolve(MODAL_FECHADO);
			}, 100);
		});
	};

	const verificarObrigatoriedadeCIDs = () =>
		new Promise((resolve) => {
			setTimeout(() => {
				showModalCID().then((statusModal) => {
					WebapiCommon.getCIDPorLaudo(props.detalhes.laudo).then((response) => {
						if (response.length <= 0)
							resolve(
								'Solicitação de liberação cancelada. Obrigatório cadastro de CID para este laudo.'
							);

						resolve(statusModal);
					});
				});
			}, 300);
		});

	const liberarLaudo = () => {
		if (
			habilitadoCertificacao &&
			!avisoCertificacaoLiberacao &&
			!props.detalhes.certificado &&
			acessoPermitido(props.usuario, acessos.CertificacaoDigital)
		) {
			props.certificacaoActions.certificadosSelecionados([
				props.detalhes.laudo,
			]);
			props.certificacaoActions.showModal(true);
			setUpdateCertificado(false);
			setAvisoCertificacaoLiberacao(true);
		} else {
			const laudo = props.detalhes;

			if (laudo.liberadoParcial && !laudo.liberadoTotal) {
				props.modalLiberarParcialmenteAction.fecharModal(
					true,
					props.liberacaoParcialHabilitada,
					laudo.laudo
				);
			} else if (!laudo.liberadoParcial && !laudo.liberadoTotal) {
				props.modalLiberarParcialmenteAction.fecharModal(
					false,
					props.liberacaoParcialHabilitada,
					laudo.laudo
				);
			}
		}
	};

	const handleLiberarLaudo = () => {
		if (props.detalhes.critico) {
			WebapiCommon.getCIDPorLaudo(props.detalhes.laudo).then((response) => {
				if (response.length <= 0) {
					verificarObrigatoriedadeCIDs().then((statusModal) => {
						if (statusModal === true) liberarLaudo();
						else
							props.commonActions.showAlerta(
								'alerta',
								statusModal,
								5000,
								'750px'
							);
					});
				} else liberarLaudo();
			});
			return;
		}
		liberarLaudo();
	};

	const fechar = () => {
		props.commonActions.changeFecharTela(true);
    	verificarPlainTextMudou();
	};

	const alterarVisibilidadeAbas = (propriedadeNoEstado) => {
		const visibilidade = !props[propriedadeNoEstado];
		const larguraEditor = visibilidade
			? 'calc(100% - 33.333333% - 10px)'
			: '100%';
		props.commonActions.alterarVisibilidadeAbas({
			[propriedadeNoEstado]: visibilidade,
		});
		props.commonActions.atualizarLarguraEditor(larguraEditor);
	};

	const modalFaturar = () => {
		WebapiCommon.getConfiguracaoLiberacaoLaudo().then((response) => {
			if (response.faturarNaConclusao && !props.detalhes.laudoFaturado) {
				props.commonActions.atualizarLaudoSelecionado({
					laudo: props.detalhes.laudo,
					prontuario: props.detalhes.prontuario,
					exame: props.detalhes.exameId,
				});
				return props.commonActions.mudarStatusModalFaturamento(true);
			} else {
				handleLiberarLaudo();
			}
		});
	}

	const construirBotoes = () => {
		const botoes = [];

		botoes.push({
			backgroundColor: '#4375A3',
			className: 'mv-basico-imprimir',
			color: '#ffffff',
			texto: intl.formatMessage({ id: 'dashboards.reports.printOut' }),
			onClick: () => editor.Imprimir(props.commonActions),
		});

		if (
			acessoPermitido(props.usuario, acessos.TopografiaMorfologia) &&
			!props.conclusaoFinalizada &&
			!props.exameFinalizado
		) {
			botoes.push({
				label: 'CID',
				backgroundColor: '#007bff',
				color: '#ffffff',
				texto: 'CID 10',
				onClick: () => verificaEditor('cid'),
			});
		}

		if (
			acessoPermitido(props.usuario, acessos.Conclusao) &&
			acessoPermitido(props.usuario, acessos.Concluir) &&
			!props.conclusaoFinalizada &&
			!props.exameFinalizado
		) {
			botoes.push({
				backgroundColor: '#3f8642',
				label: '2',
				color: '#ffffff',
				texto: intl.formatMessage({ id: 'dashboards.referral.referral' }),
				onClick: () => encaminharSegundaOpiniao(),
			});
		}

		if (acessoPermitido(props.usuario, acessos.ExamesEmAberto) && existemImagemsRadiologia) {
			botoes.push({
				backgroundColor: '#3c5d80',
				className: 'fas fa-eye',
				// label: 'Imagens',
				color: '#ffffff',
				texto: intl.formatMessage({ id: 'Vivace Connect' }),
				onClick: () => {
					urlImagemRadiologia(props.commonActions, props.detalhes.acNumber, props.detalhes.prontuario);
				},
			});
		}

		if (acessoPermitido(props.usuario, acessos.ExamesEmAberto))
		{
		botoes.push({
			backgroundColor: '#17a2b8',
			className: 'fas fa-flask',
			color: '#ffffff',
			texto: intl.formatMessage({ id: 'dashboards.examDetails.openExams' }),
			totalizador: props.quantidadeLaudosEmAberto,
			onClick: () => {
			showModal('4');
			}
		});
		}

		if (
			acessoPermitido(props.usuario, acessos.Conclusao) &&
			acessoPermitido(props.usuario, acessos.Concluir) &&
			!props.conclusaoFinalizada &&
			!props.exameFinalizado
		) {
			botoes.push({
				backgroundColor: '#3f8642',
				className: 'fas fa-save',
				color: '#ffffff',
				texto: intl.formatMessage({ id: 'dashboards.examDetail.laud' }),
				onClick: () => verificaEditor(),
			});
		}

		if (
			acessoPermitido(props.usuario, acessos.Conclusao) &&
			acessoPermitido(props.usuario, acessos.ConcluirPendente) &&
			!props.conclusaoFinalizada &&
			!props.exameFinalizado
		) {
			botoes.push({
				backgroundColor: '#b81717',
				className: 'far fa-save',
				color: '#ffffff',
				texto: intl.formatMessage({ id: 'dashboards.examDetail.laudPendent' }),
				onClick: () => laudar(true, false),
			});
		}

		if (
			acessoPermitido(props.usuario, acessos.Conclusao) &&
			acessoPermitido(props.usuario, acessos.Concluir) &&
			!props.conclusaoFinalizada &&
			!props.exameFinalizado
		) {
			botoes.push({
				backgroundColor: '#3f8642',
				className: 'fas fa-clipboard-check',
				color: '#ffffff',
				texto: intl.formatMessage({ id: 'dashboards.examDetail.laudAndConclusion' }),
				onClick: () => verificaEditor('concluir'),
			});
		}

		if (
			acessoPermitido(props.usuario, acessos.Conclusao) &&
			acessoPermitido(props.usuario, acessos.ConcluirConferencia) &&
			!props.conclusaoFinalizada &&
			!props.exameFinalizado
		) {
			botoes.push({
				backgroundColor: '#b81717',
				className: 'fas fa-file-signature',
				color: '#ffffff',
				texto: intl.formatMessage({ id: 'dashboards.examDetail.laudLecturer' }),
				onClick: () => laudar(false, false, true),
			});
		}

		if (
			acessoPermitido(props.usuario, acessos.LiberarLaudoParaEntrega) &&
			props.conclusaoFinalizada &&
			!props.detalhes.liberadoParcial &&
			!props.detalhes.liberadoTotal
		) {
			botoes.push({
				backgroundColor: '#3f8642',
				className: 'mv-basico-selecionar_todos',
				color: '#ffffff',
				texto: intl.formatMessage({ id: 'dashboards.examDetails.releaseReport' }),
				onClick: () => modalFaturar(),
				// console.log(props.detalhes)
			});
		}

		if (
			acessoPermitido(props.usuario, acessos.CancelamentoConclusao) &&
			props.conclusaoFinalizada
		) {
			botoes.push({
				backgroundColor: '#b81717',
				className: 'mv-basico-cancelar',
				color: '#ffffff',
				texto: intl.formatMessage({ id: 'dashboards.examDetail.Cancellation' }),
				atalho: 'CTRL+ALT+N',
				onClick: () => showModalConfirmarCancelamento(),
			});
		}

		botoes.push({
			backgroundColor: '#bbbbbb',
			label: 'F',
			color: '#ffffff',
			texto: intl.formatMessage({ id: 'dashboards.examDetail.close' }),
			onClick: () => fechar(),
		});

		return botoes;
	};

	const getAltura = () => `${window.innerHeight - props.altura - 160}px`;

	return (
		<React.Fragment>
			<ModalEncaminhar
				toggleModalEncaminhar={() => setModalEncaminhar(!modalEncaminhar)}
				type={modalEncaminharType}
				showModalEncaminhar={modalEncaminhar}
				titulo={'Encaminhar'}
				mensagem={'Encaminhar'}
				confirmar={() => fecharModalEncaminhar()}
				laudo={props.detalhes.laudo}
				commonActions={props.commonActions}
			/>
			<ModalFaturamentoContainer altura={getAltura()} />
			<ModalConfirmar
				toggleModalConfirmar={() => setModalConfirmar(!modalConfirmar)}
				type={modalConfirmarType}
				showModalConfirmar={modalConfirmar}
				titulo={modalConfirmarTitulo}
				mensagem={modalConfirmarMensagem}
				confirmar={() => fecharModalConfirmar()}
			/>
			<React.Fragment>
				<ModalComponentAsync size="lg" titulo={modalTitulo} ref={refModalCid}>
					<MorfologiaContainer altura={window.innerHeight - 215} />
				</ModalComponentAsync>
				<ModalComponent
					size={modalSize}
					visivel={modalVisivel}
					cancela={closeModal}
					titulo={modalTitulo}
				>
					{modalConteudo}
				</ModalComponent>
				<ConfirmarCancelamento
					isOpen={showModalConfirmarCancelamentoState}
					toggle={toggleModalConfirmarCancelamento}
					shoModalJustificativa={cancelamentoConclusao}
				/>
				<CancelamentoComponent
					isOpen={showModalCancelamento}
					toggle={toggleModalCancelamento}
					setJustificativa={setJustificativa}
					justificativaCancelar={justificativaCancelar}
					cancelarEtapa={cancelarEtapasPosteriores}
				/>
				<ModalLiberacaoParcial />
				<ModalLiberacaoTotal />
				{modalAutorizacaoLaudar && (
					<AutorizacaoLaudarContainer
						fecharTela={() => setModalAutorizacaoLaudar(false)}
						callback={callbackAutorizar}
					/>
				)}
				{props.detalhes !== undefined && (
					<Col className="paddingZero">
						<div
							style={{ height: '100%' }}
							className="detalhes-conclusao-container"
						>
							<div className="inner-menu-container">
								<Row>
									{acessoPermitido(props.usuario, acessos.AutoTexto) &&
										!props.exameFinalizado &&
										!props.conclusaoFinalizada && (
											<Col>
												<Button
													className={
														props.visibilidadeAutotexto
															? 'mv-tab-ativo'
															: undefined
													}
													onClick={() =>
														alterarVisibilidadeAbas('visibilidadeAutotexto')
													}
													color="link"
													title="CTRL+ALT+A"
												>
													<IntlMessage id="dashboards.examDetails.autoText" />
												</Button>
											</Col>
										)}
									{acessoPermitido(props.usuario, acessos.Anexo) && (
										<Col>
											<Button
												color="link"
												className={
													props.visibilidadeListagemAnexo
														? 'mv-tab-ativo'
														: undefined
												}
												onClick={() =>
													alterarVisibilidadeAbas('visibilidadeListagemAnexo')
												}
											>
												<IntlMessage id="dashboards.examDetails.attachments" />
											</Button>
										</Col>
									)}

									{acessoPermitido(props.usuario, acessos.LaudosAnteriores) && (
										<Col>
											<Button
												className={
													props.visibilidadeAutotexto
														? 'mv-tab-ativo'
														: undefined
												}
												onClick={() =>
													alterarVisibilidadeAbas(
														'visibilidadeLaudosAnteriores'
													)
												}
												color="link"
												title="CTRL+ALT+T"
											>
												<IntlMessage id="dashboards.examDetails.previousReports" />
												<Badge className="tabs-total-itens">
													{props.quantidadeLaudosAnteriores}
												</Badge>
											</Button>
										</Col>
									)}
									{acessoPermitido(props.usuario, acessos.HistoricoLaudo) && (
										<Col>
											<Button
												className={
													props.visibilidadeHistoricoLaudo
														? 'mv-tab-ativo'
														: undefined
												}
												onClick={() =>
													alterarVisibilidadeAbas('visibilidadeHistoricoLaudo')
												}
												color="link"
												title="CTRL+ALT+H"
											>
												<IntlMessage id="dashboards.examDetails.reportHistory" />
											</Button>
										</Col>
									)}
									{acessoPermitido(props.usuario, acessos.ListaLaminas) &&
										!props.exameFinalizado &&
										!props.conclusaoFinalizada && (
											<Col>
												<Button
													color="link"
													className={
														props.visibilidadeListaLaminas
															? 'mv-tab-ativo'
															: undefined
													}
													onClick={() =>
														alterarVisibilidadeAbas('visibilidadeListaLaminas')
													}
												>
													<IntlMessage id="dashboards.examDetails.bladeList" />
												</Button>
											</Col>
										)}
									<Col>
										<Button
											onClick={alterarFullscreen}
											color="link"
											title="CTRL+ALT+F10"
										>
											<i
												className={
													window.document.fullscreen
														? 'fas fa-compress'
														: 'fas fa-expand'
												}
											/>
										</Button>
									</Col>
								</Row>
							</div>
							<Row className="mv-tabs-container">
								{props.visibilidadeListaLaminas && (
									<Col
										style={{
											paddingLeft: '15px',
											minWidth: '0%',
											maxWidth: '30%',
										}}
									>
										<ListaLaminasContainer
											altura={window.innerHeight - props.altura - 214}
										/>
									</Col>
								)}

								{props.visibilidadeLaudosAnteriores &&
									acessoPermitido(props.usuario, acessos.LaudosAnteriores) && (
										<Col
											style={{
												paddingLeft: '15px',
												minWidth: '0%',
												maxWidth: '30%',
											}}
										>
											<LaudosAnterioresContainer
												altura={window.innerHeight - props.altura - 214}
											/>
										</Col>
									)}
								{props.visibilidadeAutotexto &&
									acessoPermitido(props.usuario, acessos.AutoTexto) && (
										<Col
											style={{
												paddingLeft: '15px',
												minWidth: '0%',
												maxWidth: '30%',
											}}
										>
											<AutoTextoContainer
												altura={window.innerHeight - props.altura - 214}
											/>
										</Col>
									)}
								{props.visibilidadeListagemAnexo &&
									acessoPermitido(props.usuario, acessos.Anexo) && (
										<Col
											style={{
												paddingLeft: '15px',
												minWidth: '0%',
												maxWidth: '30%',
											}}
										>
											<AnexoContainer
												altura={window.innerHeight - props.altura - 214}
											/>
										</Col>
									)}

								{props.visibilidadeHistoricoLaudo &&
									acessoPermitido(props.usuario, acessos.HistoricoLaudo) && (
										<Col
											style={{
												paddingLeft: '15px',
												minWidth: '0%',
												maxWidth: '30%',
											}}
										>
											<HistoricoLaudoContainer
												altura={window.innerHeight - props.altura - 214}
											/>
										</Col>
									)}
								<Col
									style={{
										paddingLeft: '0px',
										minWidth: '70%',
										maxWidth: '100%',
									}}
								>
									<div id="container-editor-etapa" style={{ height: '100%' }} />
								</Col>
							</Row>
							<ButtonFloating actions={construirBotoes()} />
						</div>
					</Col>
				)}
			</React.Fragment>
		</React.Fragment>
	);
}

const mapDispatchToProps = (dispatch) => ({
	actions: bindActionCreators(actions, dispatch),
	commonActions: bindActionCreators(commonActions, dispatch),
	certificacaoActions: bindActionCreators(certificacaoActions, dispatch),
	editorActions: bindActionCreators(editorActions, dispatch),
	modalLiberarParcialmenteAction: bindActionCreators(
		modalLiberarParcialmenteAction,
		dispatch
	),
	modalLiberarLaudoAction: bindActionCreators(
		modalLiberarLaudoAction,
		dispatch
	),
});

const mapStateToProps = (state) => ({
	modalCertificacao: state.certificacao.showModal,
	modalFaturamento: state.commonReducer.modalFaturamento,
	usuario: state.usuario,
	altura: state.commonReducer.altura,
	detalhes: state.commonReducer.detalhes,
	editor: state.editor,
	editorCarregado: state.commonReducer.editorCarregado,
	exameFinalizado: state.commonReducer.exameFinalizado,
	laudarEtapaRequest: state.commonReducer.laudarEtapaRequest,
	listagem: state.commonReducer.listagem,
	conclusaoFinalizada: state.conclusao.conclusaoFinalizada,
	etapaAtual: state.commonReducer.etapa.etapa,
	liberacaoParcialHabilitada: state.modalLiberacaoParcial.liberacaoParcialHabilitada,
	visibilidadeListaLaminas: state.commonReducer.visibilidadeListaLaminas,
	visibilidadeAutotexto: state.commonReducer.visibilidadeAutotexto,
	visibilidadeLaudosAnteriores: state.commonReducer.visibilidadeLaudosAnteriores,
	visibilidadeListagemAnexo: state.commonReducer.visibilidadeListagemAnexo,
	visibilidadeHistoricoLaudo: state.commonReducer.visibilidadeHistoricoLaudo,
	quantidadeLaudosAnteriores: state.commonReducer.quantidadeLaudosAnteriores,
	altura: state.commonReducer.altura,
	laudoFaturado: state.commonReducer.laudoFaturado,
	quantidadeLaudosEmAberto: state.commonReducer.quantidadeLaudosEmAberto,
    editorInicializado: state.commonReducer.editorInicializado
});

export default connect(mapStateToProps, mapDispatchToProps)(ConclusaoContainer);


// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/conclusao/conclusao.container.jsx